import { Button, FormLabel, Grid, Stack, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import ProgramFeeCard from "../cards/ProgramFee"
import { Link } from "react-router-dom"
import routes from "../../constants/routes"
import AddFee from "../modals/AddFee"
import { getFeeAll, getFeeStats } from "../../api"
import { useSnackbar } from "notistack"
import LoadingContent from "../common/LoadingContent"
import { AuthorizedFor } from "../common/AuthorizedFor"
import roles from "../../constants/roles"
import AcademicYearSelect from "../common/AcademicYearSelect"

const FeeSummary = () => {
  const { enqueueSnackbar } = useSnackbar()
  const [academicYear, setAcademicYear] = useState(2023)
  const [addFeeModal, setAddFeeModal] = useState(false)
  const [feePayments, setFeePayments] = useState([])
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [stats, setStats] = useState()

  useEffect(() => {
    let data = {
      academicYear: academicYear + "-" + (parseInt(String(academicYear).slice(-2)) + 1),
    }
    setLoading(true)
    getFeeStats(data).then((res) => {
      setStats(res.data.overallStats)

      let arr = []
      if (Object.keys(res.data.programStats).length > 0) {
        Object.keys(res.data.programStats).map((item) => {
          if (item !== "null")
            arr.push({ ...res.data.programStats[item], id: item })
        })
      }
      setList(arr)
      setLoading(false)
    })
  }, [academicYear])

  const openAddFee = () => setAddFeeModal(true)
  const closeAddFee = () => setAddFeeModal(false)
  const fetchFeePayments = (options = {}) => {
    setLoading(true)
    getFeeAll(options)
      .then((res) => {
        setFeePayments(res.data.rows)
        console.log(res.data.rows)
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  return (
    <>
      <Stack
        direction={{ xs: "col", sm: "row" }}
        gap={1}
        justifyContent="space-between"
        alignItems={"center"}
        marginBottom={2}
      >
        <AcademicYearSelect value={academicYear} setValue={setAcademicYear} />
        <Stack
          direction="row"
          spacing={3}
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            px: 5,
            py: 1,
            boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.05);",
          }}
        >
          <Stack alignItems={"center"}>
            <FormLabel sx={{ textAlign: "center" }}>Total Fee</FormLabel>
            <Typography variant="h6">₹{stats?.totalFee || 0}</Typography>
          </Stack>
          <Stack alignItems={"center"}>
            <FormLabel sx={{ textAlign: "center" }}>Total Collected</FormLabel>
            <Typography variant="h6">₹{stats?.totalCollected || 0}</Typography>
          </Stack>
          <Stack alignItems={"center"}>
            <FormLabel sx={{ textAlign: "center" }}>Total Balance</FormLabel>
            <Typography variant="h6">₹{stats?.totalBalance || 0}</Typography>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={2}>
          <AuthorizedFor roles={[roles.ADMIN, roles.STAFF]}>
            <Button onClick={openAddFee} variant="contained">
              Add Fee Payment
            </Button>
            <Link to={routes.ACCOUNTING.FEEAPPROVALS}>
              <Button variant="contained">Approve/Escalate</Button>
            </Link>
          </AuthorizedFor>
        </Stack>
      </Stack>
      <AddFee
        isOpen={addFeeModal}
        close={closeAddFee}
        refresh={fetchFeePayments}
      />
      <LoadingContent loading={loading}>
        <Grid container spacing={3} marginTop={1}>
          {list.map((item) => (
            <Grid key={item.id} item xs={12} sm={4}>
              <ProgramFeeCard key={item.id} data={item} />
            </Grid>
          ))}
        </Grid>
      </LoadingContent>
    </>
  )
}

export default FeeSummary
